import { ZammadTicketConfigurationDto } from 'services/client-api-wrapper/identity_provider/responses.dto';

/** Write payload for PATCH org `zammad_ticket_configuration`; `{}` disables the integration. */
export type IZammadTicketConfiguration = ZammadTicketConfigurationDto | Record<string, never>;

export const ZAMMAD_TICKET_MAX_CATEGORIES = 20;
export const ZAMMAD_TICKET_MAX_CATEGORY_LENGTH = 50;
